import React from 'react';
import { ImCross } from 'react-icons/im';

import classNames from 'classnames';

import * as styles from './index.module.scss';

type Props = {
  className?: string | string[];
  setVisible?: (value: boolean) => void;
  colorType?: 'info' | 'negative' | 'normal';
  children: React.ReactNode;
};

export const Message: React.FC<Props> = ({
  className,
  setVisible,
  colorType,
  children,
}) => {
  return (
    <div
      className={classNames(
        styles.root,
        colorType === 'info' && styles.info,
        colorType === 'negative' && styles.negative,
        colorType === 'normal' && styles.normal,
        className,
      )}
    >
      {setVisible && (
        <ImCross
          className={styles.closeIcon}
          onClick={() => setVisible(false)}
        />
      )}
      {children}
    </div>
  );
};
